import * as React from 'react';
/**
 *
 * Original name: fail
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=12634%3A11
 *
 */
export const FailSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { d: "M94.947 25.053C86.95 17.055 75.192 13 60 13c-15.192 0-26.95 4.055-34.947 12.053C17.056 33.051 13 44.809 13 60c0 15.191 4.055 26.949 12.053 34.947C33.051 102.945 44.808 107 60 107c15.192 0 26.95-4.055 34.947-12.053C102.944 86.949 107 75.191 107 60c0-15.191-4.055-26.949-12.053-34.947ZM60 101c-27.206 0-41-13.794-41-41s13.794-41 41-41 41 13.794 41 41-13.794 41-41 41Z", fill: "currentColor" }),
    React.createElement("path", { d: "M60.121 64.364 76.758 81 81 76.758 64.364 60.12l16.879-16.878L77 39 60.121 55.879 43.243 39 39 43.243 55.879 60.12 39.242 76.758 43.485 81 60.12 64.364Z", fill: "currentColor" })));
